<template>
  <div class="step-a-wrapper">

    <div><h3 class="mb-20" style="color: #1890ff;">Section 2: Applied and Working (Currently Employed)</h3></div>
    <a-form layout="vertical" :form="formStepB">
      <!-- Q6 Type of Job -->
      <a-row :gutter="[16, 16]">
        <a-col :sm="24" :xs="12" :md="12">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">6. Type of Job</span> 
            </template>
            <a-select 
              v-model="form.jobType" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.jobType',
                { rules: [{ required: true, message: 'Please input your Type of Job' }] },
              ]"
            >
              <a-select-option value="01">(01) Civil Servant/Employee in a government organization</a-select-option>
              <a-select-option value="02">(02) Staff/Employee in a State-Enterprise Agency</a-select-option>
              <a-select-option value="03">(03) Staff/Employee in a private company</a-select-option>
              <a-select-option value="04">(04) Your own business/family business</a-select-option>
              <a-select-option value="05">(05) Employee in an international organization</a-select-option>
              <a-select-option value="00">(00) Others </a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.jobType === '00'" v-model="form.jobTypeOther" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q7 Skills -->
      <a-row :gutter="[16, 16]">
        <a-col :sm="24" :xs="12" :md="12">
          <a-form-item>

            <template slot="label">
              <span class="font-web font-weight-bold" style="">7. Which skill can most help you to get employed ?</span> 
            </template>

            <a-select 
              v-model="form.employableSkill" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.employableSkill',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="01">(01) Foreign Languages</a-select-option>
              <a-select-option value="02">(02) Computer literacy</a-select-option>
              <a-select-option value="03">(03) Extra curriculum activities</a-select-option>
              <a-select-option value="04">(04) Art</a-select-option>
              <a-select-option value="05">(05) Sport</a-select-option>
              <a-select-option value="00">(00) Others </a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.employableSkill === '00'" v-model="form.employableSkillOther" />

          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q8-9 -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :md="12">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">8. Position</span> 
            </template>
            <a-input 
              v-model="form.position" 
              v-decorator="[
                'form.position',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">9. Organization Name</span> 
            </template>
            <a-input 
              v-model="form.organizationName" 
              v-decorator="[
                'form.organizationName',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q9.1 Industry -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Industry (Please specify 1 item)</span> 
            </template>
            <a-checkbox-group 
              v-model="form.industries"
              v-decorator="[
                'form.industries',
                {
                  initialValue: form.industries,
                  rules: [
                    { required: true, type: 'array', min: 1, message: 'Please select at least 1 industry', trigger: 'change' }
                  ]
                }
              ]"
            >
              <a-row>
                <a-col :span="12"><a-checkbox value="A">(A) Agriculture / Forestry / Fisheries</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="B">(B) Mining</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="C">(C) Production</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="D">(D) Power & Energy / Oil & Gas / HVAC</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="E">(E) Water Supply / Waste Management</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="F">(F) Construction</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="G">(G) Motor Vehicles / Auto Repair</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="H">(H) Logistics and Warehouse</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="I">(I) Hospitality / Catering</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="J">(J) Information and Communication</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="K">(K) Financial Services/Insurance</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="L">(L) Real Estate</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="M">(M) Professional / Science / Academic</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="N">(N) Management Consultancy & Business Support</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="O">(O) Civil Services / Social Security</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="P">(P) Education</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="Q">(Q) Healthcare / Charity / NGO</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="R">(R) Art / Entertainment / Recreation</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="S">(S) General Business Services</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="T">(T) Small Family Owned Business</a-checkbox></a-col>
                <a-col :span="12"><a-checkbox value="U">(U) International Organization / Association</a-checkbox></a-col>
              </a-row>
            </a-checkbox-group>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q10-Q17 -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :md="12">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">10. Monthly salary or earned income (Baht)</span> 
            </template>
            <a-input 
              v-model="form.salary" 
              placeholder="e.g. 15000" 
              v-decorator="[
                'form.salary',
                { rules: [{ required: true, message: 'Please input salary' }] },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">11. Is monthly salary in line with your qualification and education ?</span> 
            </template>
            <a-radio-group 
              v-model="form.isSalaryMatch"
              v-decorator="[
                'form.isSalaryMatch',
                { rules: [{ required: true, message: 'Please input salary' }] },
              ]"
            >
              <a-radio value="1">Yes</a-radio>
              <a-radio value="2">No <a-input v-model="form.salaryReason" style="width: 200px; display: inline-block; margin-left: 10px;" /></a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">12. Are you satisfied with your work ?</span> 
            </template>
            <a-select 
              v-model="form.satisfaction" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.satisfaction',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="01">(01) Satisfaction</a-select-option>
              <a-select-option value="02">(02) Undesirable working system</a-select-option>
              <a-select-option value="03">(03) Undesirable co-worker</a-select-option>
              <a-select-option value="04">(04) Not match with your qualification/ability</a-select-option>
              <a-select-option value="05">(05) Little payment</a-select-option>
              <a-select-option value="06">(06) No stability</a-select-option>
              <a-select-option value="07">(07) No opportunity for promotion</a-select-option>
              <a-select-option value="00">(00) Others</a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.satisfaction === '00'" v-model="form.unsatisfiedOther" />
          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">13. After graduation, how long did it take you to get a job</span> 
            </template>
            <a-select 
              v-model="form.getJobDuration" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.getJobDuration',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="01">(01) Immediately</a-select-option>
              <a-select-option value="02">(02) 1 - 2 months</a-select-option>
              <a-select-option value="03">(03) 3 - 6 months</a-select-option>
              <a-select-option value="04">(04) 7 - 9 months</a-select-option>
              <a-select-option value="05">(05) 10 - 12 months</a-select-option>
              <a-select-option value="06">(06) Over 1 year</a-select-option>
              <a-select-option value="07">(07) An old job</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">14. How did you get your job ?</span> 
            </template>
            <a-select 
              v-model="form.getJobSource" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.getJobSource',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="1">(1) Company website</a-select-option>
              <a-select-option value="2">(2) Newspaper job post</a-select-option>
              <a-select-option value="3">(3) Private source</a-select-option>
              <a-select-option value="4">(4) MU job board</a-select-option>
              <a-select-option value="5">(5) Scholarship Commitment</a-select-option>
              <a-select-option value="6">(0) Others</a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.getJobSource === '0'" v-model="form.jobSourceOther" />
          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">15. Have you worked in the field that you graduated ?</span> 
            </template>
            <a-select 
              v-model="form.jobFieldMatch" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.jobFieldMatch',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="1">(1) Yes</a-select-option>
              <a-select-option value="2">(2) No</a-select-option>
            </a-select>
            <a-input class="mt-20" v-if="form.jobFieldMatch === '00'" v-model="form.jobFieldReason" />
          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">16. How can you apply your knowledge to your work ?</span> 
            </template>

            <a-select 
              v-model="form.applyKnowledge" 
              show-search 
              placeholder="Select..." 
              v-decorator="[
                'form.applyKnowledge',
                { rules: [{ required: true, message: 'Please input' }] },
              ]"
            >
              <a-select-option value="01">(01) To a very great extent</a-select-option>
              <a-select-option value="02">(02) To a great extent</a-select-option>
              <a-select-option value="03">(03) To a moderate extent</a-select-option>
              <a-select-option value="04">(04) A little</a-select-option>
              <a-select-option value="05">(05) Very little</a-select-option>
            </a-select>

          </a-form-item>
        </a-col>
        <a-col :xs="24">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">17. Do you want to further your study ?</span> 
            </template>
            <a-radio-group @change="handleFurtherStudyChange" v-model="form.wantFurtherStudy">
              <a-radio value="1">Yes</a-radio>
              <a-radio value="2">No</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- controll -->
    <div class="text-right">
      <a-button-group>
        <a-button @click="backSection" type="primary"> <a-icon type="left" />Go back </a-button>
        <a-button @click="submitAndValidateB" type="primary"> Go forward<a-icon type="right" /> </a-button>
      </a-button-group>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formStepB: this.$form.createForm(this, { name: 'stepB' }),
      form: {
        jobType: '',
        jobTypeOther: '',
        employableSkill: '',
        employableSkillOther: '',
        position: '',
        organizationName: '',
        industries: [],
        salary: '',
        salaryReason: '',
        isSalaryMatch: '',
        satisfaction: '',
        unsatisfiedOther: '',
        getJobDuration: '',
        getJobSource: '',
        jobSourceOther: '',
        jobFieldMatch: '',
        jobFieldReason: '',
        applyKnowledge: '',
        wantFurtherStudy: ''
      }
    };
  },
  mounted() {},
  methods: {
    handleFurtherStudyChange(e) {
      const val = e.target.value;
      this.form.wantFurtherStudy = val;
      this.formStepB.validateFields((err, values) => {
        if (!err) {
          this.$emit('updateData', 'stepB', { ...this.form, ...values.form, wantFurtherStudy: val });
          if (val === '1') setTimeout(() => { this.$emit('NextSectionSkip', 3); }, 400);
          else if (val === '2') setTimeout(() => { this.$emit('NextSectionSkip', 4); }, 400);
        }
      });
    },
    backSection() {
      this.$emit('backSection')
    },
    submitAndValidateB() {
      this.formStepB.validateFields((err, values) => {
        if (!err) {
          const further = this.form.wantFurtherStudy;
          if (further === '1') {
            this.$emit('updateData', 'stepB', { ...this.form, ...values.form, wantFurtherStudy: further });
            setTimeout(() => { this.$emit('NextSectionSkip', 3); }, 400);
          } else {
            this.$emit('updateData', 'stepB', { ...this.form, ...values.form, wantFurtherStudy: further });
            setTimeout(() => { this.$emit('NextSectionSkip', 4); }, 400);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.step-a-wrapper {
  padding: 20px;
}

.radio-group-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 100%;
}

.radio-group-wrap .radio-text {
  display: inline-block;
  max-width: 100%;
  white-space: normal;      /* อนุญาตให้ขึ้นบรรทัดใหม่ */
  word-break: break-word;   /* ตัดคำถ้าจำเป็น */
  line-height: 1.4;
}
</style>
